import Axios from 'axios';
import moment from 'moment-timezone';
import { protectedResources } from '../authConfig';

let tokenKey;

export async function UploadExcelMasterFile(fileInput, limit, offset, batchNo) {
  const URL_UPLOAD =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/UniformSurveyBackend/UniformSurveyImport';
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  var formData = new FormData();
  var imagefile = document.querySelector('#file');
  formData.append('Image', fileInput);
  formData.append('limit', limit);
  formData.append('offset', offset);
  formData.append('batchNo', batchNo);
  const config = {
    headers: {
      Authorization: `Bearer ${tokenKey}`,
      'Content-Type': 'multipart/form-data',
    },
  };
  try {
    const response = await Axios.post(URL_UPLOAD, formData, config);
    return await response;
  } catch (error) {
    throw new Error(error.response.data.detail);
  }
}

export async function GetUniformBenefitIncorrect(params, type) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  localStorage.setItem('uniFormType', params.uniFormType);

  try {
    const response = await Axios.post(
      protectedResources.apiHRMobile.baseApi +
        '/api/v1/UniformSurvey/GetUniformBenefitIncorrect',
      params,
      config,
    );
    return await response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function UniformDeleteByEmployeeID(surveyId) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const URL_DEL =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/UniformSurveyBackend/DeleteUniformSurvey';
  const config = {
    headers: {
      Authorization: `Bearer ${tokenKey}`,
    },
  };
  try {
    const response = await Axios.delete(
      URL_DEL + '?surveyId=' + surveyId,
      config,
    );
    return await response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function UniformBenefitById(employeeId) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };
  try {
    const response = await Axios.get(
      protectedResources.apiHRMobile.baseApi +
        '/api/v1/UniformSurveyBackend/GetUniformBenefit?emailOrId=' +
        employeeId,
      config,
    );
    return await response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function UniformLastest(employeeId, searchType) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const queryParam = searchType === 'employeeId7Digit'
    ? 'employeeId7Digit=' + employeeId
    : 'employeeId=' + employeeId;

  try {
    const response = await Axios.get(
      protectedResources.apiHRMobile.baseApi +
        '/api/v1/UniformSurvey/GetUniformSurvey?' + queryParam,
      config,
    );
    return await response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function GetUniformSchedules() {
  const URL =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/UniformSurveyBackend/GetUniformSchedule';
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  //const bodyParameters = params;

  try {
    const response = await Axios.get(URL, config);
    return await response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function GetUpdateUniformSchedules(params) {
  const URL =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/UniformSurveyBackend/SetUniformSurveyScheduleUpdate';
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  // Always use Asia/Bangkok offset (+07:00) so all machines submit the same time
  const timeOffsetStr = '+07:00';
  const fmtWithOffset = (d) =>
    moment(d).format('yyyy-MM-DDTHH:mm:00.000') + timeOffsetStr;

  const bodyParameters = {
    ...params,
    // Override startDate/endDate (from ...params, no TZ) with explicit +07:00 so
    // the backend parses them as Bangkok time and stores the correct UTC value.
    startDate: fmtWithOffset(params.startDate),
    endDate: fmtWithOffset(params.endDate),
    startDateStr: fmtWithOffset(params.startDate),
    endDateStr: fmtWithOffset(params.endDate),
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function GetUniformSurveysItemList(filter, limitNo = 'yes') {
  const URL =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/UniformSurveyBackend/GetUniformSurveys';
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };
  let bodyParameters = {};
  if (limitNo === 'no') {
    bodyParameters = {
      limit: 0,
      offset: filter.offset,
      employeeId: filter.search,
      status: 10,
      year: filter.year,
    };
  } else {
    bodyParameters = filter;
  }

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export async function setRequestDashboard(year, month) {
  const URL =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/UniformSurveyBackend/GetUniformSurveyRequestSummary';
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: year,
    month: month,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    // Silent fail
  }
}

export async function getChartAmount(year) {
  const URL =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/UniformSurveyBackend/GetUniformSurveyRequestChart';
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: year,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    // Silent fail
  }
}
